export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000/api/v1';

export const SUPPORT_PHONE =
  import.meta.env.VITE_SUPPORT_PHONE || '918800123456';
